document.addEventListener("DOMContentLoaded", () => {
	/* customers(공통) - 회원 아이디(이메일) URL PARAM 적용처리 */
	setURLParam("user_email", "input", "input_user_email");

	/* 로그인 페이지 쿠키정보 체크 */
	checkLoginCookie();

	/* 로그인 버튼 클릭 */
	clickBtnLogin();

	/* 비밀번호 표시상태 아이콘 클릭  */
	let icon_pw = document.querySelector('.email_login__form .user-pw-show-btn');
	if (icon_pw != null) {
		icon_pw.addEventListener('click', function (e) {
			let el = e.currentTarget;

			let input_pw = document.querySelector('.email_login__form #customer_password');
			if (input_pw.type === 'password') {
				input_pw.type = 'text';
				el.style.backgroundImage = `url(${iconPwShow})`;
			} else {
				input_pw.type = 'password';
				el.style.backgroundImage = `url(${iconPwUnShow})`;
			}
		});
	}

	/* customers (공통) - 페이지 keyup 입력항목 체크 */
	keyupParamUser()

	/* customers (공통) - 페이지 링크 클릭 */
	clickLinkUser()

	// 주소 값에 user_email param이 있으면 이메일 로그인 버튼 클릭 처리
	let urlParams = new URLSearchParams(window.location.search);

  	if (urlParams.has("user_email")) {
		let emailLoginButton = document.querySelector(".container__user .account__form-block .btn_login_email");

		if(emailLoginButton) {
			emailLoginButton.click();
		}
  	}

	let return_url = urlParams.get("return_url");
	if(return_url && return_url.includes("my_product")) {
		const regiBtn = document.querySelectorAll(".container__user .gtm-sign-up");
		regiBtn.forEach(btn => {
			btn.dataset.gtmClickType = "버튼_to_나의등록제품";
		});
	}
});

// param 확인 후 쿠키 설정 (현재는 referral 파라미터만 체크)
function setCookieFromUrlParam() {
	let url_obj = new URL(location.href);
	let encoded_url = url_obj.searchParams.get('return_url');
	let cookie_obj = new Object();

	if(!encoded_url) {
		let prev_page = new URL(document.referrer).pathname;

		if(prev_page == '/' || prev_page == '/pages/customers-register-sidiz' || prev_page.startsWith('/account')) {
			cookie_obj.type = 'tab';
			cookie_obj.to = 'home';
		} else {
			cookie_obj.type = 'page';
			cookie_obj.to = prev_page;
		}
	} else {
		let decoded_url = decodeURIComponent(encoded_url);
		let param = new URLSearchParams(decoded_url.split('?')[1]).get('tab');
	
		if(param == 'referral') {
			param = 'coupon';
		}

		cookie_obj.type = 'tab';
		cookie_obj.to = param;
	}

	setCookie('redirect', JSON.stringify(cookie_obj), 1);
}

function setCookie(cookieName, value, exdays) {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);

    let cookieValue = encodeURIComponent(value) + "; path=/;";
    
    if(exdays) {
        cookieValue += " expires=" + exdate.toUTCString() + ";";
    }

    document.cookie = cookieName + "=" + cookieValue;
}

/* 로그인 페이지 쿠키정보 체크 */
function checkLoginCookie() {
	let input_mail = document.querySelector('#customer_email');
	let savedIdFlag = getUserEmailCookie('save-id-flag') === 'true';
	let cookieIdValue = decodeURIComponent(getUserEmailCookie('save-id-value'));
	let savedIdValue = '';

	if (cookieIdValue && cookieIdValue !== "undefined" && cookieIdValue != null) {
		savedIdValue = cookieIdValue;
	}

	if (savedIdFlag && savedIdValue) {
		let regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

		$(".remember__user").prop("checked", true);
		input_mail.value = savedIdValue;

		if (!regexEmail.test(savedIdValue)) {
			let msgMail = document.querySelector(".msg_user_email");
			input_mail.dataset.check_result = "F";
			setValidateResult(false, input_mail, msgMail, "올바른 이메일 형식이 아닙니다.");
		} else {
			input_mail.dataset.check_result = "T";
		}
  	}

	function getUserEmailCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
}

/* 시디즈 로그인 버튼 클릭 */
function clickBtnLogin() {
	/* 이메일로 로그인 입력 폼 표시 */
	let btn_mail = document.querySelector(".container__user .account__form-block .btn_login_email");
	if (btn_mail != null) {
		btn_mail.addEventListener('click',function() {
			document.querySelector(".email_login__form").classList.remove('hidden');
			document.querySelector(".account__form-block").classList.add('hidden');
		});
	}

	let btn_login_S = document.querySelector('.btn_login_sidiz');
	if (btn_login_S != null) {
		btn_login_S.addEventListener('click', function () {
			checkFormData();

			let check_result = btn_login.dataset.check_result;
			if (check_result != "T") {
				/* 로그인 페이지 PARAM 체크 */
				let param_user = document.querySelectorAll('.param_user');
				if (param_user != null && param_user.length > 0) {
					param_user.forEach(param => {
						let param_type	= param.dataset.param_type;
						let param_value = param.value;

						let param_msg	= document.querySelector(`.msg_${param_type}`);
						if (param_value != null && param_value.length > 0) {
							checkParamUser(param_type,param,param_msg,param_value);
						} else {
							param_obj.dataset.check_result = "F";

							let txt_param_type = getTxtParamType(param_type);
							setValidateResult(false,param,param_msg,`${txt_param_type} 미입력`);
						}
					});
				}
			} else {
				/* 아이디(이메일) 쿠키 저장 */
				if ($('.remember__user').prop('checked')) {
					let user_mail = document.querySelector('#customer_email').value;
					setCookie("user_email", user_mail, null);
				} 
				else {
					deleteCookie("user_email");
				}
			}
		});
	}

	/* 카카오 로그인 버튼 클릭 */
	let btn_login_K = document.querySelector('.btn_login_kakao');
	if (btn_login_K != null) {
		btn_login_K.addEventListener('click', function () {
			let oauth_kakao		= "https://kauth.kakao.com/oauth/";
			let client_kakao	= "fc74e41fba98520112740ae101843b2c";
			let redirect_kakao	= "https://kr.sidiz.com/pages/kakao-login";
			
			sessionStorage.setItem('action_type',"LOGIN");
			
			let tmp_url = `${oauth_kakao}authorize?client_id=${client_kakao}&redirect_uri=${redirect_kakao}&response_type=code`;
			location.href = tmp_url;

			setCookieFromUrlParam();
		});
	}

	/* 네이버 로그인 버튼 클릭 */
	let btn_login_N = document.querySelector('.btn_login_naver');
	if (btn_login_N != null) {
		btn_login_N.addEventListener('click', function () {
			let oauth_naver		= "https://nid.naver.com/oauth2.0/";
			let client_naver	= "VY9Euld75KN5q1u0upZD";
			let redirect_naver	= encodeURI("https://kr.sidiz.com/pages/naver-login");
			let mt				= Date.now().toString();
			let rand			= Math.random().toString();
			let state			= CryptoJS.MD5(mt + rand).toString();
			
			sessionStorage.setItem('action_type',"LOGIN");

			let tmp_url = `${oauth_naver}authorize?response_type=code&client_id=${client_naver}&redirect_uri=${redirect_naver}&state=${state}`;
			location.href = tmp_url;

			setCookieFromUrlParam();
		});
	}

	/* 이메일 로그인 버튼 클릭 */
	let btn_login_M = document.querySelector('.btn_email_login');
	if (btn_login_M != null) {
		SidizCustomerLogin.bindForm(btn_login_M.closest('form'), btn_login_M);
		btn_login_M.addEventListener('click',function(e) {
			e.preventDefault();

			let param_mail	= document.querySelector('#customer_email').value;
			let msg_mail	= document.querySelector('.msg_user_email');

			let param_pw	= document.querySelector('#customer_password').value;
			let msg_pw		= document.querySelector('.msg_user_pw');

			// 유효성 검증
			let errors = validateLoginForm(param_mail,param_pw);

			// 에러 메시지 초기화
			msg_mail.textContent = "";
			msg_mail.classList.add('hidden');

			msg_pw.textContent = "";
			msg_pw.classList.add('hidden');

			if (Object.keys(errors).length > 0) {
				if (errors.email) {
					msg_mail.textContent = errors.email;
					msg_mail.classList.remove('hidden');
				}

				if (errors.password) {
					msg_pw.textContent = errors.password;
					msg_pw.classList.remove('hidden');
				}
				return;
			}

			// 유효성 검증 통과 시 로그인 처리
			checkEmailExists(param_mail).then(emailExists => {
				if (emailExists) {
					handleEmailLogin(param_mail,param_pw);
				}
			});
		});
	}
}

function validateLoginForm(email, password) {
	const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
	const errors = {};

	if (!email.trim()) {
		errors.email = "이메일을 입력해주세요.";
	} else if (!emailRegex.test(email)) {
		errors.email = "올바른 이메일 형식을 입력해주세요.";
	}

	if (!password.trim()) {
		errors.password = "비밀번호를 입력해주세요.";
	}

	return errors;
}

function handleEmailLogin(param_mail,param_pw) {
	const loginForm = document.querySelector('#customer_login');
	return SidizCustomerLogin.submit({ email: param_mail, password: param_pw, form: loginForm })
	.then((response) => {
		closeLoadingModal();
		if (response.redirected && response.url.includes('/account/login')) {
			let msg_pw = document.querySelector('.email_login__form .msg_user_pw');
			msg_pw.textContent = "비밀번호가 일치하지 않습니다.";
			msg_pw.classList.remove('hidden');
		} 
		else {
			// 쿠키 저장 모달과 통일
			let rememberUser = document.querySelector('.remember__user');
			let user_mail = document.querySelector('#customer_email').value;

			if (rememberUser.checked) {
				// 아이디 저장 기능이 활성화된 경우
				document.cookie = 'save-id-flag=true; path=/';
				document.cookie = `save-id-value=${encodeURIComponent(user_mail)}; path=/`;
			} 
			else {
				// 아이디 저장이 비활성화된 경우 쿠키 삭제
				document.cookie = 'save-id-flag=false; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
				document.cookie = 'save-id-value=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
			}

			// GTM
			localStorage.setItem('gtmCustomerEvent', 'L');
			localStorage.setItem('gtmCustomerLoginMethod','Email');

			kakaoPixel('6421355729020341302').pageView();
			kakaoPixel('6421355729020341302').login();

			try {
				const body = JSON.stringify({ customer_id: param_mail });
				const blob = new Blob([body], { type: "application/json" });
				navigator.sendBeacon("https://sidiz-shopify.sidiz.com/v1/coupons/login-auto-issue", blob);
			} catch (e) {
				console.warn("⚠️ 쿠폰 발급 요청 실패 (beacon 전송 오류):", e);
			}

			location.href = SidizCustomerLogin.accountUrl();

			setCookieFromUrlParam();
		}
	})
	.catch((error) => {
		SidizCustomerLogin.showError(loginForm, error);
	});
}
